import React, { useLayoutEffect } from 'react';
import { getMatchStreamingProps } from '../data/streaming/streamingUtils';
import { filterBetsByNumberOfOdds, filtraParametriche, getConfiguration, iconCategoryCssClass } from '../data/utils';
import { getLabel } from '../InitData';
import { LiveSectionContext } from '../live/common/LiveSection';
import { CustomCols } from '../live/Live';
import { adjustOddsAlignment } from '../tables-utils';
import BetsOddsHeader from './BetsOddsHeader';
import TournamentLiveMatch from './TournamentLiveMatch';

function Tournament(props) {
    const liveSectionContext = React.useContext(LiveSectionContext);
    const customCols = React.useContext(CustomCols);
    let bets = props.events[0].bets;
    bets = filtraParametriche(bets);
    bets = filterBetsByNumberOfOdds(bets, customCols);
    const conf = getConfiguration();

    const matchesList = props.events.map((match, index) => {
        const streamingMap = getMatchStreamingProps(match);
        return (
            <TournamentLiveMatch key={match.id}
                                 match={match}
                                 changeMatch={props.changeMatch}
                                 selected={liveSectionContext.match.id === match.id}
                                 streaming={streamingMap && streamingMap[match.id]}
                                 isLiveSuite={props.isLiveSuite}
                                 moreBetsEnabled={props.moreBetsEnabled}
                                 openWidget={index === 0} />
        );
    });

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    return (
        <div className="contenitore-table bg-bianco">
            <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live " + (props.collapse ? 'collapsed' : '')} data-toggle="collapse" data-target={`#tournament-collapse-${props.id}`}>
                <div className={`img-fluid img-flags margine-dx-mezzo ico-cat icoCategory${props.sportRef}-${props.categoryRef} ${iconCategoryCssClass(props.sportRef, props.categoryRef, props.iconClass)}`}></div>
                <span>{props.categoryDesc} - {props.descrizione} {conf.iwh && <span className='badge__live'>Live</span>}</span>
            </div>
            <div className={!props.collapse?'collapse show':'collapse'} id={`tournament-collapse-${props.id}`}>
                <div className="collapse show" id="paese-calcio-1-aa">
                    <div className="tabellaQuoteIntestazione text_s1 mb-2">
                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center pointer">
                            <p>{getLabel('live_page.tournament_header.time')}</p>
                        </div>
                        <div className="tabellaQuoteCampetto">&nbsp;</div>
                        <div className="tabellaQuoteSquadre d-flex justify-content-center align-items-center"></div>
                        <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                            <BetsOddsHeader bets={bets} />
                        </div>
                        <div className="tabellaQuoteStatistiche"></div>
                        <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                    </div>
                    {matchesList}
                </div>
            </div>
        </div>
    );
}

const TournamentMemo = React.memo(Tournament, (prevProps, nextProps) => {
    if (prevProps.events === nextProps.events && prevProps.collapse === nextProps.collapse) {
      return true;
    }
    return false;
  });

export default TournamentMemo;
